
class LanguageData {
    constructor() {
        this.languageMap = {
            en: [
                {
                    id: 0,
                    title: 'Business Automation',
                    options: [
                        'I want to schedule a meeting about business automation',
                        'I need help automating my business processes',
                        'I want to learn which tools to use for automation',
                        'Discuss opportunities for automating multiple processes',
                    ],
                },
                {
                    id: 1,
                    title: 'Course Purchase',
                    options: [
                        'Help me choose the right course',
                        'I want to know about course prices',
                        'Can I purchase a course for my team?',
                        'Are there discounts for buying multiple courses?',
                    ],
                },
                {
                    id: 2,
                    title: 'Faceless Channels',
                    options: [
                        'I want to learn about creating faceless content',
                        'Let’s discuss how faceless channels generate income',
                        'Help me understand the benefits of a faceless channel',
                        'Schedule a meeting to discuss faceless channels',
                    ],
                },
                {
                    id: 3,
                    title: 'Automatic Social Media Uploads',
                    options: [
                        'I want to set up automatic uploads for my business',
                        'Help me automate my uploads across platforms',
                        'What are the benefits of automating social media uploads?',
                        'Discuss the setup process for automatic uploads',
                    ],
                },
                {
                    id: 4,
                    title: 'Help',
                    options: [
                        'Help me choose a course',
                        'I have a technical issue with the platform',
                        'I have questions about commissions or payments',
                        'Let’s discuss a custom solution for my needs',
                    ],
                },
            ],
            he: [
                {
                    id: 0,
                    title: 'אוטומציה עסקית',
                    options: [
                        'אני רוצה לקבוע פגישה לגבי אוטומציה עסקית',
                        'אני צריך עזרה באוטומציה של תהליכים עסקיים',
                        'אני רוצה לדעת אילו כלים מתאימים לאוטומציה',
                        'לדון באפשרויות לאוטומציה של מספר תהליכים',
                    ],
                },
                {
                    id: 1,
                    title: 'רכישת קורסים',
                    options: [
                        'לעזור לי לבחור את הקורס המתאים',
                        'אני רוצה לדעת מה המחיר של הקורסים',
                        'האם ניתן לרכוש קורס לצוות שלי?',
                        'האם יש הנחות על רכישת מספר קורסים?',
                    ],
                },
                {
                    id: 2,
                    title: 'ערוצי הכנסה פאסיבית',
                    options: [
                        'אני רוצה ללמוד על יצירת הכנסה פאסיבית',
                        'לדון כיצד ערוצים ללא פנים מייצרים הכנסה',
                        'לעזור לי להבין את היתרונות של ערוץ ללא פנים',
                        'לקבוע פגישה לדון בערוצים ללא פנים',
                    ],
                },
                {
                    id: 3,
                    title: 'העלאות אוטומטיות למדיה חברתית',
                    options: [
                        'אני רוצה להגדיר העלאות אוטומטיות לעסק שלי',
                        'לעזור לי לבצע אוטומציה להעלאות ברשתות חברתיות',
                        'מה היתרונות של העלאות אוטומטיות למדיה חברתית?',
                        'לדון בתהליך ההגדרה של העלאות אוטומטיות',
                    ],
                },
                {
                    id: 4,
                    title: 'עזרה',
                    options: [
                        'לעזור לי לבחור קורס',
                        'יש לי בעיה טכנית עם הפלטפורמה',
                        'יש לי שאלות לגבי עמלות או תשלומים',
                        'לדון בפתרון מותאם לצרכים שלי',
                    ],
                },
            ],
        };

        this.content = {
            en: {
                title: 'Contact Us',
                description: 'Do you want to make a business automation for your Business or create faceless channels',
            },
            he: {
                title: 'צור קשר',
                description: 'האם אתה רוצה לבצע אוטומציה עסקית לעסק שלך או לייצר הכנסה פאסיבית',
            },
        };
    }

    getLanguageMap() {
        return this.languageMap;
    }

    getContent(){
        return this.content;
    }

    getContent(language) {
        return this.content[language];
    }
}

export default new LanguageData();